module.exports = __webpack_public_path__ + "img/HalfCoverPicture.62ea3bd7.png";